import { FlexGrid, FlexGridCellTemplate, FlexGridColumn } from '@grapecity/wijmo.react.grid';
import { CellType, DataMap } from '@grapecity/wijmo.grid';
import * as wjGrid from '@grapecity/wijmo.grid';
import { useMaster } from 'context/MasterContext';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { useRestApi } from 'context/RestApiContext';
import { MessageModal } from 'components/modal/MessageModal';
import ConstructionInfo from 'views/ClientInfo/ConstructionInfo';
import QuoteInfo from 'views/ClientInfo/QuoteInfo';
import AddInvoiceInfo from 'views/ClientInfo/AddInvoiceInfo';
import ContractEntry from 'views/ContractEntry';
import ContractInfo from 'views/ClientInfo/ContractInfo';
import OrderDestSelectModal from 'views/Order/OrderDestSelectModal';
import WarrantyEntryModal from 'views/Warranty/WarrantyEntryModal';
import InvoiceEntryModal from 'views/Invoice/InvoiceEntryModal';
import ConstructionProgressEditModal from 'views/ConstructionRequestList/ConstructionProgressEditModal';
import ConstructionScheduleEditModal from 'views/ConstructionScheduleList/ConstructionScheduleEditModal';
import InspectionScheduleEditModal from 'views/InspectionScheduleList/InspectionScheduleEditModal';
import TextComponent from 'components/Input/TextComponent';
import StatusLableComponent from 'components/Input/StatusLableComponent';
import { ClientType } from 'constants/constants';

function ClientInfo() {
  const restApi = useRestApi();

  // 画面パラメタを取得
  const location = useLocation();

  // 画面遷移履歴
  const navigate = useNavigate();

  // 確認ダイアログ
  const [dialog, setDialog] = useState({});

  // 工事履歴
  const [constructionList, setConstructionList] = useState([]);
  // アフター履歴
  const [inspectionList, setInspectionList] = useState([]);
  // 工事工程履歴
  const [constructionScheduleList, setConstructionScheduleList] = useState([]);
  // 見積り履歴
  const [quoteList, setQuoteList] = useState([]);
  // 契約履歴
  const [contractList, setContractList] = useState([]);
  // 追加請求
  const [addInvoiceList, setAddInvoiceList] = useState([]);
  // 注文書履歴
  const [orderList, setOrderList] = useState([]);
  // 請求一覧
  const [seikyuList, setSeikyuList] = useState([]);
  // 保証書
  const [warrantyList, setWarrantyList] = useState([]);
  // 請求書
  const [invoiceList, setInvoiceList] = useState([]);
  // 工事状況
  const [constructionProgress, setConstructionProgress] = useState([]);

  // 契約入力モーダルへのパラメタ
  const [contractModalParam, setContractModalParam] = useState({});
  // 保証書モーダルへのパラメタ
  const [warrantyModalParam, setWarrantyModalParam] = useState({});
  // 工事状況モーダルへのパラメタ
  const [constructionScheduleEditModalParam, setConstructionScheduleEditModalParam] = useState({});
  // 工事状況モーダルへのパラメタ
  const [constructionProgressEditModalParam, setConstructionProgressEditModalParam] = useState({});
  // アフター状況モーダルへのパラメタ
  const [inspectionScheduleEditModalParam, setInspectionScheduleEditModalParam] = useState({});
  // 請求書モーダルへのパラメタ
  const [invoiceModalParam, setInvoiceModalParam] = useState({});

  // 顧客情報
  const [clientInfo, setClientInfo] = useState({
    NAME_SEI_1: '',
    NAME_MEI_1: '',
    PREF: '',
    CITY: '',
    TOWN: '',
    ADDRESS: '',
    POST_CODE: '',
    TEL1: '',
    TEL_RELATION_1: '',
    HOUSE_MAKER: '',
    HOUSE_HIKIWATASHI: '',
    TAN_CD: '',
  });

  // マスタ情報
  const master = useMaster();

  var constructionStatusMap = new DataMap(master.constructionStatus, 'id', 'name');
  const planerWithEmpty = [...master.planer, { id: 0, name: '' }];
  const planerMap = new DataMap(planerWithEmpty, 'id', 'name');

  // 初期表示
  useEffect(() => {
    // 検索処理
    search(location?.state?.clientId, location?.state?.seikyuNo);
  }, []);

  // 選択中の工事の請求NO
  const [selectedSeikyuNo, setSelectedSeikyuNo] = useState(-1);

  // 工事の請求NOの変更処理
  useEffect(() => {
    const clientId = location?.state?.clientId;
    searchSeikyu(clientId, selectedSeikyuNo);
  }, [selectedSeikyuNo]);

  // 請求関連情報を検索
  const searchSeikyu = (clientId, seikyuNo) => {
    // 請求NOの指定がない場合は処理しない
    if (seikyuNo == -1) {
      return;
    }
    restApi.get(`/api/client/info/${clientId}/${seikyuNo}`, (data) => {
      // 見積もり履歴
      setQuoteList(data.quoteList.filter((x) => x.MOTO_KEI_NO == 0));
      // 追加請求
      setAddInvoiceList(
        data.quoteList.filter((x) => x.MOTO_KEI_NO == 1).map((x, i) => ({ ...x, NO: i + 1 }))
      );
      // 契約履歴
      setContractList(data.contractList.map((x, i) => ({ ...x, NO: i + 1 })));
      // 注文書履歴
      setOrderList(data.orderList.map((x, i) => ({ ...x, NO: i + 1 })));
      // 請求一覧
      setSeikyuList([...data.seikyuList]);
      // 保証書
      setWarrantyList([...data.seikyuList.filter((x) => x.HIKI_DATE)]);
      // 請求書
      setInvoiceList([...data.seikyuList.filter((x) => x.SEIKYU_DATE)]);
      // 工事状況
      setConstructionProgress(
        data.constructionProgress.map((item) => {
          const finalAmount = parseFloat(item.FINAL_AMOUNT) || 0;
          const genka = parseFloat(item.SEIKYU_GENKA) || 0;
          const rate = finalAmount === 0 ? 0 : genka / finalAmount;
          return {
            ...item,
            GENKA_RATE: rate,
          };
        })
      );
      // 工事工程
      setConstructionScheduleList([...data.constructionScheduleList]);
      // アフター状況
      setInspectionList(formatInspectionList(data.inspectionList));
    });
  };

  // 注文書作成処理
  const handleOnClickOrderCreate = () => {
    if (contractList?.length > 0) {
      setOrderDestSelectParam({ keiNo: contractList[0].KEI_NO });
    }
  };

  // 保証書作成
  const handleOnClickWarrantyEdit = (mode, item) => {
    setWarrantyModalParam({
      mode: mode,
      seikyuNo: item.SEIKYU_NO,
      hikiDate: item.HIKI_DATE,
    });
  };

  // 工事工程編集
  const handleOnClickConstructionScheduleEdit = () => {
    setConstructionScheduleEditModalParam({
      call_list: false,
      constructionData: constructionScheduleList[0],
    });
  };

  // 工事状況編集
  const handleOnClickConstructionProgressEdit = () => {
    setConstructionProgressEditModalParam({
      call_list: false,
      constructionData: constructionProgress[0],
    });
  };

  // グリッド
  const flexGrid = useRef();

  // アフター状況編集
  const handleOnClickInspectionScheduleEdit = () => {
    setInspectionScheduleEditModalParam({
      call_list: false,
      inspectionData: inspectionList[0],
    });
  };

  // 工事完了確認書の印刷
  const handleOnClickConstructionCompletionPrint = (item) => {
    restApi.postDownload(`/api/construction/completion/report/${item.SEIKYU_NO}`, {}, `工事完了確認書.xlsx`, () => { })
  };

  // 保証書の印刷
  const handleOnClickWarrantyPrint = (item) => {
    restApi.getToPdf(`/api/warranty/report/${item.SEIKYU_NO}`);
  };

  // 顧客情報検索
  const search = (clientId, seikyuNo = -1) => {
    restApi.get(`/api/client/info/${clientId}`, (data) => {
      // 工事情報
      setConstructionList(data.constructionList);

      // 選択行が未設定の場合は先頭行の工事を選択
      if (seikyuNo == -1 && data.constructionList.length > 0) {
        setSelectedSeikyuNo(data.constructionList[0].SEIKYU_NO);
      } else {
        setSelectedSeikyuNo(seikyuNo);
      }

      // 顧客情報
      setClientInfo(data.client);
    });
  };

  // 契約入力からのコールバック処理
  const callbakContractModal = () => {
    // 再読み込み
    searchSeikyu(location?.state?.clientId, selectedSeikyuNo);
    search(location?.state?.clientId, selectedSeikyuNo);
  };

  //  グリッドの初期化
  function onInitialized(grid) {
    // ヘッダーを2段にする
    var extraRow = new wjGrid.Row();
    extraRow.allowMerging = true;

    var panel = grid.columnHeaders;
    panel.rows.splice(0, 0, extraRow);
    for (let i = 1; i <= 5; i++) {
      panel.setCellData(0, i, `6箇月点検`);
    }
    for (let i = 6; i <= 10; i++) {
      panel.setCellData(0, i, `1年点検`);
    }
    for (let i = 11; i <= 15; i++) {
      panel.setCellData(0, i, `3年点検`);
    }

    // ヘッダーの中央揃え
    for (let i = 0; i < grid.columns.length; i++) {
      grid.columns[i].cssClassAll = 'header-center';
    }
  }
  //  グリッドのフォーマット
  function formatItem(s, e) {
    const item = e.panel.rows[e.row]?.dataItem;
    if (!item) return;
    // 区切り線
    if (e.col === 1 || e.col === 6 || e.col === 11 || e.col === 16) {
      e.cell.style.borderLeft = 'double #4c4c4c';
    }
    const col = e.col;

    const flgCheckMap = {
      M6: {
        flg: item.M6_INSPECTION_FLG,
        keys: ['M6_PLAN_FORMAT', 'M6_CARD_SEND_FORMAT', 'M6_CARD_RETURN_FORMAT', 'M6_INSPECT_DATE_FORMAT', 'M6_INSPECT_TAN'],
        startCol: 1,
      },
      Y1: {
        flg: item.Y1_INSPECTION_FLG,
        keys: ['Y1_PLAN_FORMAT', 'Y1_CARD_SEND_FORMAT', 'Y1_CARD_RETURN_FORMAT', 'Y1_INSPECT_DATE_FORMAT', 'Y1_INSPECT_TAN'],
        startCol: 6,
      },
      Y3: {
        flg: item.Y3_INSPECTION_FLG,
        keys: ['Y3_PLAN_FORMAT', 'Y3_CARD_SEND_FORMAT', 'Y3_CARD_RETURN_FORMAT', 'Y3_INSPECT_DATE_FORMAT', 'Y3_INSPECT_TAN'],
        startCol: 11,
      },
    };

    // 値がない場合のみ「-」を表示
    Object.values(flgCheckMap).forEach(({ flg, keys, startCol }) => {
      if (col >= startCol && col < startCol + keys.length && flg !== 1) {
        const key = keys[col - startCol];
        if (!item[key]) {
          e.cell.textContent = '-';
        }
      }
    });

    // 直近の点検の文字色を青色にする
    const highlightCurrentOrNextMonth = (value) => {
      if (!value) return false;
      const now = new Date();
      const current = `${String(now.getFullYear()).slice(2)}年${String(now.getMonth() + 1).padStart(2, '0')}月`;
      const next = `${String(now.getFullYear() + (now.getMonth() + 1 === 12 ? 1 : 0)).slice(2)}年${String((now.getMonth() + 2) % 13 || 1).padStart(2, '0')}月`;
      return value === current || value === next;
    };

    const planCols = {
      1: item.M6_PLAN_FORMAT,
      6: item.Y1_PLAN_FORMAT,
      11: item.Y3_PLAN_FORMAT,
    };

    if (Object.keys(planCols).includes(e.col.toString())) {
      const planValue = planCols[e.col];
      if (highlightCurrentOrNextMonth(planValue)) {
        e.cell.style.color = 'blue';
      }
    }
  }

  const normalizeDateStr = (dateStr) => {
    // "-" または "/" で分割
    return dateStr.includes('-') ? dateStr.split('-') : dateStr.split('/');
  };

  const formatDateToYYM = (dateStr) => {
    if (!dateStr) return '';
    const [year, month] = normalizeDateStr(dateStr);
    const yy = year.slice(2);
    const m = month.padStart(2, '0');
    return `${yy}年${m}月`;
  };

  const formatDateToYMD = (dateStr) => {
    if (!dateStr) return '';
    const [year, month, day] = normalizeDateStr(dateStr);
    const mm = String(month).padStart(2, '0');
    const dd = String(day).padStart(2, '0');
    return `${year}/${mm}/${dd}`;
  };

  const formatDateToMMDD = (dateStr) => {
    if (!dateStr) return '';
    const [_, month, day] = normalizeDateStr(dateStr);
    const mm = month.padStart(2, '0');
    const dd = day.padStart(2, '0');
    return `${mm}/${dd}`;
  };

  const formatInspectionList = (data) => {
    const formattedData = data.map((item) => ({
      ...item,
      HIKI_DATE_FORMAT: formatDateToYMD(item.HIKI_DATE),
      M6_PLAN_FORMAT: formatDateToYYM(item.M6_PLAN),
      Y1_PLAN_FORMAT: formatDateToYYM(item.Y1_PLAN),
      Y3_PLAN_FORMAT: formatDateToYYM(item.Y3_PLAN),
      M6_CARD_SEND_FORMAT: formatDateToMMDD(item.M6_CARD_SEND),
      M6_CARD_RETURN_FORMAT: item.M6_CARD_RETURN_BIKO
        ? item.M6_CARD_RETURN_BIKO
        : formatDateToMMDD(item.M6_CARD_RETURN),
      M6_INSPECT_DATE_FORMAT: formatDateToMMDD(item.M6_INSPECT_DATE),
      Y1_CARD_SEND_FORMAT: formatDateToMMDD(item.Y1_CARD_SEND),
      Y1_CARD_RETURN_FORMAT: item.Y1_CARD_RETURN_BIKO
        ? item.Y1_CARD_RETURN_BIKO
        : formatDateToMMDD(item.Y1_CARD_RETURN),
      Y1_INSPECT_DATE_FORMAT: formatDateToMMDD(item.Y1_INSPECT_DATE),
      Y3_CARD_SEND_FORMAT: formatDateToMMDD(item.Y3_CARD_SEND),
      Y3_CARD_RETURN_FORMAT: item.Y3_CARD_RETURN_BIKO
        ? item.Y3_CARD_RETURN_BIKO
        : formatDateToMMDD(item.Y3_CARD_RETURN),
      Y3_INSPECT_DATE_FORMAT: formatDateToMMDD(item.Y3_INSPECT_DATE),
    }));
    return formattedData;
  };

  return (
    <>
      <Card className="m-0">
        <Card.Body>
          <Row>
            <Col className="pr-1" md="1">
              <Form.Group>
                <label>顧客区分</label>
                <TextComponent
                  value={
                    clientInfo.CLIENT_TYPE == ClientType.USER
                      ? '個人'
                      : clientInfo.CLIENT_TYPE == ClientType.CORP
                        ? '法人'
                        : '公共'
                  }
                  type="text"
                  disabled={true}
                ></TextComponent>
              </Form.Group>
            </Col>
            <Col className="pr-1" md="2">
              <Form.Group>
                <label>顧客名</label>
                <TextComponent
                  value={`${clientInfo.NAME_1}`}
                  type="text"
                  disabled={true}
                ></TextComponent>
              </Form.Group>
            </Col>
            <Col className="pr-1" md="4">
              <Form.Group>
                <label>住所</label>
                <TextComponent
                  value={`${clientInfo.PREF}${clientInfo.CITY}${clientInfo.TOWN}${clientInfo.ADDRESS}`}
                  type="text"
                  disabled={true}
                ></TextComponent>
              </Form.Group>
            </Col>
            <Col className="pr-1" md="1">
              <Form.Group>
                <label>郵便番号</label>
                <TextComponent
                  value={`${clientInfo.POST_CODE}`}
                  type="text"
                  disabled={true}
                ></TextComponent>
              </Form.Group>
            </Col>
            <Col className="pr-1" md="3">
              <Form.Group>
                <label>電話番号１</label>
                <TextComponent
                  value={
                    clientInfo.TEL_RELATION_1
                      ? `${clientInfo.TEL1} (${clientInfo.TEL_RELATION_1})`
                      : `${clientInfo.TEL1}`
                  }
                  type="text"
                  disabled={true}
                />
              </Form.Group>
            </Col>
          </Row>
          <br />
          {/** 工事情報 */}
          <ConstructionInfo
            clientInfo={clientInfo}
            constructionList={constructionList}
            setConstructionList={setConstructionList}
            selectedSeikyuNo={selectedSeikyuNo}
            setSelectedSeikyuNo={setSelectedSeikyuNo}
            search={search}
            searchSeikyu={searchSeikyu}
          />
          <br />
          {/** 見積もり情報 */}
          <QuoteInfo
            quoteList={quoteList}
            selectedSeikyuNo={selectedSeikyuNo}
            setContractModalParam={setContractModalParam}
            clientInfo={clientInfo}
            contractList={contractList}
          />
          <br />
          {/* 契約情報 */}
          <ContractInfo
            clientInfo={clientInfo} // 顧客情報
            contractList={contractList} // 契約一覧
            selectedSeikyuNo={selectedSeikyuNo} // 選択中の請求番号
            quoteList={quoteList} // 見積一覧
            setContractModalParam={setContractModalParam} // 契約編集モーダルパラメタ
            callbakContractModal={callbakContractModal} // 契約入力のコールバック処理
            orderList={orderList} // 注文一覧
            addInvoiceList={addInvoiceList} // 追加請求一覧
            constructionList={constructionList} // 工事一覧
            seikyuList={seikyuList} // 請求一覧
          />

          <br />
          {/** 追加請求 */}
          <AddInvoiceInfo
            addInvoiceList={addInvoiceList}
            selectedSeikyuNo={selectedSeikyuNo}
            clientInfo={clientInfo}
            contractList={contractList}
            invoiceList={invoiceList}
          />
          <br />
          <Row>
            <Col md="8">
              <Row>
                <Col>
                  <div className="list-label1">工事工程</div>
                </Col>
                <Col style={{ textAlign: 'right' }}>
                  <br />
                </Col>
              </Row>
              <Row>
                <Col>
                  <div>
                    <FlexGrid
                      ref={flexGrid}
                      itemsSource={constructionScheduleList}
                      selectionMode={'None'}
                      isReadOnly={true}
                      headersVisibility={'Column'}
                      loadedRows={(grid) => {
                        grid.rows.forEach((ele) => {
                          ele.height = 38;
                        });
                      }}
                    >
                      <FlexGridColumn
                        binding="JINKOU"
                        header="人工"
                        width={95}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        binding="OLD_TAN_CD"
                        header="旧担当"
                        dataMap={planerMap}
                        width={95}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        binding="TAN_MEETING_FLG_DISP"
                        header="担当打合"
                        width={95}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        binding="GREETING_FLG_DISP"
                        header="挨拶連絡"
                        width={95}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        binding="KOUKI_ST"
                        header="着工(作業)予定日"
                        width={105}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        binding="WORK_SCHEDULED_DATE"
                        header="作業日連絡"
                        width={95}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        binding="KOUKI_ED"
                        header="完成予定日"
                        width={95}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        binding="CONSTRUCTION_SCHEDULE_BIKO"
                        header="備考"
                        width="2*"
                      ></FlexGridColumn>
                      <FlexGridColumn header="工事工程編集" align={'center'} binding="" isReadOnly={true} width={113}>
                        <FlexGridCellTemplate
                          cellType="Cell"
                          template={(cell) => (
                            <span>
                              <Button
                                className="material-symbols-rounded cell-icon btn-fill"
                                variant="primary"
                                title="編集"
                                onClick={() => handleOnClickConstructionScheduleEdit()}
                              >
                                edit
                              </Button>
                            </span>
                          )}
                        />
                      </FlexGridColumn>
                    </FlexGrid>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md="8">
              <Row>
                <Col>
                  <div className="list-label1">工事状況</div>
                </Col>
                <Col style={{ textAlign: 'right' }}>
                  <br />
                </Col>
              </Row>
              <Row>
                <Col>
                  <div>
                    <FlexGrid
                      itemsSource={constructionProgress}
                      selectionMode={'None'}
                      isReadOnly={true}
                      headersVisibility={'Column'}
                      loadedRows={(grid) => {
                        grid.rows.forEach((ele) => {
                          ele.height = 38;
                        });
                      }}
                    >
                      <FlexGridColumn
                        binding="CONSTRUCTION_STATUS"
                        header="ステータス"
                        width="2*"
                        dataMap={constructionStatusMap}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        binding="GENBA_TAN_CD"
                        header="現場"
                        dataMap={planerMap}
                        width={95}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        binding="KOUKI_ST_ACT"
                        header="着工日"
                        width={95}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        binding="HIKI_DATE"
                        header="引渡日"
                        width={95}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        binding="SEIKYU_KINGAKU"
                        header="金額変更(税抜)"
                        width={105}
                        align={'right'}
                        allowResizing={false}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        binding="FINAL_AMOUNT"
                        header="最終金額(税抜)"
                        width={105}
                        align={'right'}
                        allowResizing={false}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        binding="SEIKYU_GENKA"
                        header="原価金額(税抜)"
                        width={105}
                        align={'right'}
                        allowResizing={false}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        binding="GENKA_RATE"
                        header="原価率"
                        width={70}
                        format="p1"
                        align={'right'}
                        allowResizing={false}
                      ></FlexGridColumn>
                      <FlexGridColumn header="工事完了確認書" align={'center'} binding="" isReadOnly={true} width={100}>
                        <FlexGridCellTemplate
                          cellType="Cell"
                          template={(cell) => (
                            <span>
                              <Button
                                className="material-symbols-rounded cell-icon btn-fill"
                                variant="primary"
                                title="工事完了確認書印刷"
                                disabled={cell.item.HIKI_DATE == ''}
                                onClick={() => handleOnClickConstructionCompletionPrint(cell.item)}
                              >
                                download
                              </Button>
                            </span>
                          )}
                        />
                      </FlexGridColumn>
                      <FlexGridColumn header="保証書" align={'center'} binding="" isReadOnly={true} width={60}>
                        <FlexGridCellTemplate
                          cellType="Cell"
                          template={(cell) => (
                            <span>
                              <Button
                                className="material-symbols-rounded cell-icon btn-fill"
                                variant="primary"
                                title="保証書印刷"
                                disabled={cell.item.HIKI_DATE == ''}
                                onClick={() => handleOnClickWarrantyPrint(cell.item)}
                              >
                                print
                              </Button>
                            </span>
                          )}
                        />
                      </FlexGridColumn>
                      <FlexGridColumn header="工事状況編集" align={'center'} binding="" isReadOnly={true} width={100}>
                        <FlexGridCellTemplate
                          cellType="Cell"
                          template={(cell) => (
                            <span>
                              <Button
                                className="material-symbols-rounded cell-icon btn-fill"
                                variant="primary"
                                title="編集"
                                onClick={() => handleOnClickConstructionProgressEdit()}
                              >
                                edit
                              </Button>
                            </span>
                          )}
                        />
                      </FlexGridColumn>
                    </FlexGrid>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md="12">
              <Row>
                <Col>
                  <div className="list-label1">アフター状況</div>
                </Col>
                <Col style={{ textAlign: 'right' }}>
                  <br />
                </Col>
              </Row>
              <Row>
                <Col>
                  <div>
                    <FlexGrid
                      ref={flexGrid}
                      itemsSource={inspectionList}
                      selectionMode={'None'}
                      isReadOnly={true}
                      initialized={onInitialized}
                      formatItem={formatItem}
                      allowMerging="ColumnHeaders"
                      headersVisibility={'Column'}
                      loadedRows={(grid) => {
                        grid.rows.forEach((ele) => {
                          ele.height = 38;
                        });
                      }}
                    >
                      <FlexGridColumn
                        binding="AFTER_NUMBER"
                        header="No"
                        allowResizing={false}
                        width={95}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        binding="M6_PLAN_FORMAT"
                        header="点検予定月"
                        allowResizing={false}
                        width={95}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        binding="M6_CARD_SEND_FORMAT"
                        header="葉書発送"
                        allowResizing={false}
                        width={95}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        binding="M6_CARD_RETURN_FORMAT"
                        header="葉書返信"
                        allowResizing={false}
                        width={95}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        binding="M6_INSPECT_DATE_FORMAT"
                        header="点検実施日"
                        allowResizing={false}
                        width={95}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        binding="M6_INSPECT_TAN"
                        header="実施担当"
                        allowResizing={false}
                        width={95}
                        dataMap={planerMap}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        binding="Y1_PLAN_FORMAT"
                        header="点検予定月"
                        allowResizing={false}
                        width={95}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        binding="Y1_CARD_SEND_FORMAT"
                        header="葉書発送"
                        allowResizing={false}
                        width={95}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        binding="Y1_CARD_RETURN_FORMAT"
                        header="葉書返信"
                        allowResizing={false}
                        width={95}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        binding="Y1_INSPECT_DATE_FORMAT"
                        header="点検実施日"
                        allowResizing={false}
                        width={95}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        binding="Y1_INSPECT_TAN"
                        header="実施担当"
                        allowResizing={false}
                        width={95}
                        dataMap={planerMap}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        binding="Y3_PLAN_FORMAT"
                        header="点検予定月"
                        allowResizing={false}
                        width={95}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        binding="Y3_CARD_SEND_FORMAT"
                        header="葉書発送"
                        allowResizing={false}
                        width={95}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        binding="Y3_CARD_RETURN_FORMAT"
                        header="葉書返信"
                        allowResizing={false}
                        width={95}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        binding="Y3_INSPECT_DATE_FORMAT"
                        header="点検実施日"
                        allowResizing={false}
                        width={95}
                      ></FlexGridColumn>
                      <FlexGridColumn
                        binding="Y3_INSPECT_TAN"
                        header="実施担当"
                        allowResizing={false}
                        width={95}
                        dataMap={planerMap}
                      ></FlexGridColumn>
                      <FlexGridColumn header="アフター状況編集" align={'center'} binding="" isReadOnly={true} width={108}>
                        <FlexGridCellTemplate
                          cellType="Cell"
                          template={(cell) => (
                            <span>
                              <Button
                                className="material-symbols-rounded cell-icon btn-fill"
                                variant="primary"
                                title="編集"
                                onClick={() => handleOnClickInspectionScheduleEdit()}
                              >
                                edit
                              </Button>
                            </span>
                          )}
                        />
                      </FlexGridColumn>
                    </FlexGrid>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* 契約モーダル */}
      <ContractEntry
        contractModalParam={contractModalParam}
        callbakContractModal={callbakContractModal}
      ></ContractEntry>

      {/** 保証書モーダル */}
      <WarrantyEntryModal params={warrantyModalParam} callbak={callbakContractModal} />

      {/** 工事状況モーダル */}
      <ConstructionScheduleEditModal params={constructionScheduleEditModalParam} callbak={callbakContractModal} />

      {/** 工事状況モーダル */}
      <ConstructionProgressEditModal params={constructionProgressEditModalParam} callbak={callbakContractModal} />
      {/** アフター状況モーダル */}
      <InspectionScheduleEditModal params={inspectionScheduleEditModalParam} callbak={callbakContractModal} />

      {/** 請求書モーダル */}
      <InvoiceEntryModal params={invoiceModalParam} callbak={callbakContractModal} />

      {/** メッセージモーダル */}
      <MessageModal dialog={dialog}></MessageModal>
    </>
  );
}

export default ClientInfo;
